import { NgClass } from '@angular/common';
import { booleanAttribute, Component, input } from '@angular/core';

@Component({
    selector: 'app-panel',
    template: `
        <div class="rounded-3 {{ class() }}" [ngClass]="[withPanel() ? 'bg-white shadow p-3' : '', panelClass()]">
            <ng-content/>
        </div>
    `,
    imports: [NgClass],
})
export class PanelComponent {
    class = input<string>('');
    panelClass = input<string>('');
    withPanel = input<boolean, unknown>(true, {transform: booleanAttribute});
}
